export { Proxy } from './Proxy';
export { DashboardProxy } from './DashboardProxy';
export { AuthProxy } from './AuthProxy';


// WEBPACK FOOTER //
// ./src/proxies/index.js